const Member = 'Member';
const Veteran = 'Veteran';
const General = 'General';
const ITEMS = {
    Member,
    Veteran,    
    General
};

export default {
    Member, 
    Veteran, 
    General,
    ITEMS
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/EmailCategory.js